<div class="page-content">
    <h2 class="content-title">Access denied</h2>
    <div class="content-message">
        You do not have access to this page
    </div>
</div>

<div class="bottom-color">
    <div class="img-background"></div>
    <div class="light-gray-color"></div>
    <div class="gray-color"></div>
</div>
